import { render, staticRenderFns } from "./TeacherList.vue?vue&type=template&id=1bc403a0&scoped=true&"
import script from "./TeacherList.vue?vue&type=script&lang=ts&"
export * from "./TeacherList.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherList.vue?vue&type=style&index=0&id=1bc403a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc403a0",
  null
  
)

export default component.exports